import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Ids, setFormOpen } from "../reducers/rhapsody";
import { useProject } from "../redux/project/projectHooks";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/joy";
import { Cover } from "../hooks/cover/cover";
import { useContractors } from "../redux/contractor/contractorHooks";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { GigsDatagrid } from "../hooks/gigsDatagrid/gigsDatagrid";
import { RouterConfig } from "../hooks/config/routerConfig";
import { compatibleSources } from "../global";
import Calendar from "../hooks/calendar/calendar";
import { ProjectGeneral } from "../hooks/projectGeneral/projectGeneral";
import { useDispatch } from "react-redux";
import { proEnabled } from "../constants";

export function useProjectIDs(): Ids {
  const [searchParams] = useSearchParams();
  const sourceID = parseInt(searchParams.get("sourceID"));
  const sourceRecordID = parseInt(searchParams.get("sourceRecordID"));
  const id = parseInt(searchParams.get("id"));
  return { id, sourceID, sourceRecordID };
}

/**
 *
 * @returns {ReactElement} ProjectPage page
 */
export function ProjectPage() {
  const dispatch = useDispatch();
  const projectIDs = useProjectIDs();
  const { project, isLoading } = useProject(projectIDs);
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  const { contractors } = useContractors();
  const gigs = project?.gigs;
  const contractorID = gigs?.length ? gigs[0].contractorID : undefined;
  const contractor = contractors?.find(
    (e) =>
      compatibleSources(project?.sourceID, project?.sourceID) &&
      e.sourceRecordID == contractorID
  );

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        justifyContent: isLoading ? "center" : undefined,
        alignItems: isLoading ? "center" : undefined,
        // maxWidth: 1200,
        // background: "red",
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        p: 2,
      }}
    >
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: 2,
          }}
        >
          <Button
            color="neutral"
            variant="soft"
            onClick={() => navigate(RouterConfig.projects)}
            startDecorator={<i className="fa-solid fa-chevron-left"></i>}
            size="sm"
          >
            Back
          </Button>
          <Grid container sx={{ width: "100%" }} spacing={2}>
            <Grid xs={12} md={8}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Cover size={92} url={project?.coverURL} type="project" />
                <Box>
                  <Typography
                    startDecorator={
                      contractor?.coverURL ? (
                        <img src={contractor?.coverURL} height={18} />
                      ) : (
                        []
                      )
                    }
                    level="body2"
                    sx={{ fontWeight: 600 }}
                  >
                    {contractor?.name}
                  </Typography>
                  <Typography level="h5" sx={{ fontWeight: 600 }}>
                    {project.name}
                  </Typography>
                  <Typography level="body2">
                    {project.dateDescription()}
                  </Typography>
                  <Typography level="body2">
                    {project.sessionTypeDescription()}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              xs={12}
              md={4}
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "end",
                // flexDirection: "column",
              }}
            >
              <Box sx={{ width: "100%", textAlign: "right", maxWidth: 200 }}>
                <Typography level="body2" color="primary">
                  {project.completion()}% completed (
                  {project.completedGigCount()}/{project.gigCount()})
                </Typography>
                <LinearProgress
                  thickness={8}
                  determinate
                  value={project.completion()}
                />
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ width: "100%" }}>
            <Tabs
              onChange={(e, v) => setCurrentTab(v)}
              value={currentTab}
              variant="scrollable"
              sx={{ width: "100%" }}
            >
              <Tab sx={{ textTransform: "none" }} value={0} label="Services" />
              <Tab sx={{ textTransform: "none" }} value={1} label="Calendar" />
              <Tab sx={{ textTransform: "none" }} value={2} label="General" />
            </Tabs>
            <Divider />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              width: "calc(100vw - 32px)",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {currentTab === 0 ? (
              <>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  {proEnabled ? (
                    <Button
                      onClick={() => {
                        dispatch(setFormOpen({ isOpen: true, formID: "gig" }));
                      }}
                      size="sm"
                      color="info"
                    >
                      + New Service
                    </Button>
                  ) : (
                    []
                  )}
                </Box>

                <GigsDatagrid projectID={project.sourceRecordID} />
              </>
            ) : (
              []
            )}
            {currentTab === 1 ? (
              <Calendar
                projectID={project.sourceRecordID}
                disableCreate={project.sourceID !== 420}
              />
            ) : (
              []
            )}
            {currentTab === 2 ? <ProjectGeneral /> : []}
          </Box>
        </Box>
      )}
    </Box>
  );
}
